import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { N800 } from "@atlaskit/theme/colors";

// adding updated id text to trigger new translations
//@ts-ignore
const newText = (
    <FormattedMessage
        id="siteActivation.nameSite.inputSiteNameHelperText"
        defaultMessage="This site name is just a suggestion. Feel free to change to something your team will recognize."
    />
);

export const HelperText = () => {
    return (
        <p css={helperTextCss}>
            <FormattedMessage
                id="BxpUiSignup.nameSite.inputSiteNameMessage"
                defaultMessage="This site name is just a suggestion. Feel free to change to something your team will recognize."
            />
        </p>
    );
};

const helperTextCss = css({
    color: N800,
    fontSize: "0.75rem",
    lineHeight: 1.5,
    margin: "0.5rem 0 1.5rem"
});
